import React from 'react';

import { noop } from 'lodash';

import CaretIcon from '~/core/iconComponents/icons/CaretIcon';
import cn from '~/utils/cn';

interface BreadcrumbItemProps {
  label?: string;
  action?: () => void;
}

export const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({ label, action }) => {
  if (!label) {
    return null;
  }

  return (
    <div className="flex items-center gap-4">
      <CaretIcon direction="right" />
      <span className={cn('rounded-md p-8', { 'cursor-pointer': !!action })} onClick={action || noop}>
        {label}
      </span>
    </div>
  );
};
